/* eslint-disable react/no-array-index-key */
import video1 from '../../assets/images/png/article2.png';
import video2 from '../../assets/images/png/article3.png';
import { HeadingDescSmall } from '../Headings';
import './latestVideos.css';

const data = [
  { video: video1, title: 'Top Neuro Surgeon in Lahore - Dr. Sabir Hussa…' },
  { video: video2, title: 'Top Neuro Surgeon in Lahore - Dr. Sabir Hussa…' },
  { video: video1, title: 'Top Neuro Surgeon in Lahore - Dr. Sabir Hussa…' }
];

function LatestVideos() {
  return (
    <div className="latestVideos">
      {data.map((list, index) => {
        const { video, title } = list;
        return (
          <div className="singleVideo" key={index}>
            <div className="videoBox">
              <img src={video} alt="video" />
            </div>
            <div className="content">
              <HeadingDescSmall text={<b>{title}</b>} />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default LatestVideos;
